import { useContext } from "react";
import { SettingsContext } from "../contexts/settings";
import { getHeaderText } from "./dynamic-text-utils";

export interface UseGiftReceiptLoginResponse {
  texts: { title: string; subtitle: string; merchantName: string };
  logo: string;
  onBack: (() => void) | undefined;
}

export function useGiftReceiptLogin({
  onBack,
}: {
  onBack?: () => void;
}): UseGiftReceiptLoginResponse {
  const settings = useContext(SettingsContext);

  return {
    texts: {
      title: getHeaderText(settings, true),
      subtitle: "Find your order to create or manage gift receipts.",
      merchantName: settings?.merchantName || "Unknown Merchant",
    },
    logo: settings?.theme.logo_image || "",
    onBack,
  };
}
